import { Select } from "@nulogy/components";
import WorkOrder from "domain/WorkOrder";
import React from "react";
import FilterLabel from "./FilterLabel";

const workOrderStatuses = [
  { label: "Open", value: WorkOrder.STATUS_TYPES.OPEN },
  { label: "Booked", value: WorkOrder.STATUS_TYPES.BOOKED },
  { label: "Closed", value: WorkOrder.STATUS_TYPES.CLOSED },
  { label: "Cancelled", value: WorkOrder.STATUS_TYPES.CANCELLED },
];

export default function StatusSelector({ selectedStatuses, onChange }) {
  return (
    <>
      <FilterLabel value="Work order status" />
      <Select
        className="spec-status-filter-multiselect"
        closeMenuOnSelect={false}
        maxHeight="250"
        multiselect
        onChange={onChange}
        options={workOrderStatuses}
        placeholder="Select..."
        value={selectedStatuses}
      />
    </>
  );
}
